import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

// Actions
import { gamesActions, gameActions } from '../../actions';

import Header from '../../components/Header';
import List from '../../components/List';
import SimCard from '../../components/SimCard';

// Simulate list of mini digital activities
import apiCatalog from './data';

const CatalogPage = () => {
  // State
  const [preview, setPreview] = useState(null);

  // Hooks
  const dispatch = useDispatch();
  //   const games = useSelector((state) => state.games);
  const { t } = useTranslation();

  // Effects
  useEffect(() => {
    dispatch(gameActions.setData(null));
    dispatch(gamesActions.fetchGames());
  }, [dispatch]);

  // Methods
  const handleOnPreview = (simId) => {
    console.log(simId);
    setPreview(simId);
  };

  // Logic
  const itemsCards = apiCatalog.map((simData) => {
    return (
      <div key={simData._id} className={`${preview ? 'col-12' : 'col-6'} mb-4`}>
        {simData && (
          <SimCard
            {...simData}
            isPreview={preview === simData._id}
            onPreview={handleOnPreview}
          />
        )}
      </div>
    );
  });

  const previewURL = preview
    ? `${process.env.REACT_APP_GAME_URL}/preview?sid=${preview}&hh=1`
    : null;

  return (
    <div className='d-flex flex-column vh-100'>
      <Header />

      <h2 className='mt-3 fs-2 mt-4 fw-light mb-4'>
        <span className='ms-1'>{t('Catalog')}</span>
      </h2>

      <div className='row flex-grow-1'>
        {/* Catalog items */}
        <div className={preview ? 'col-6' : 'col-12'}>
          <div className='row'>{itemsCards}</div>
        </div>

        {/* Preview */}
        {preview && (
          <div className='col-6 pb-3 position-relative'>
            <div className='card shadow overflow-hidden h-100'>
              <a
                href={previewURL}
                className='small position-absolute top-0 end-0 me-2 mt-2 px-2 py-1 rounded bg-dark text-white'
                style={{ zIndex: 999 }}
                target='_blank'
                rel='noreferrer'>
                {/* <FontAwesomeIcon icon='external-link-alt' /> */}
                {/* <span className='ms-2'>{t('Open in new tab')}</span> */}
                <span>{t('Open in new tab')}</span>
              </a>
              <iframe
                src={previewURL}
                title='Preview'
                className='w-100 h-100'
                allowFullScreen
                allow='autoplay; encrypted-media'></iframe>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export { CatalogPage };
